const getStrokeTransitionValue = ({
  strokeDuration, strokeEasing, strokeStaggerStep, strokeDelay, i,
}) => `stroke-dashoffset ${parseFloat(strokeDuration)}s ${strokeEasing} ${i * parseFloat(strokeStaggerStep) + parseFloat(strokeDelay)}s`

export default getStrokeTransitionValue
